import React, { NavLink } from "react";

const Chatbot = () => {
  return (
    <div>
      {/* <NavLink to="./ind.html">1</NavLink>
       */}
    </div>
  );
};

export default Chatbot;
